export default "/images/MurielleMoneron.jpg?8c242c0d2b8c8e6c451379c1b25aac32";